(function () {
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  function hardUnlock(swiper, el) {
    if (!swiper || !el || !isMobile()) return;

    try {
      // Empêche Swiper de se locker en pensant "tout rentre"
      swiper.params.watchOverflow = false;

      // Force l'autorisation de glisser
      swiper.allowTouchMove = true;
      swiper.params.allowTouchMove = true;

      // 🔥 C'EST LA CLÉ chez toi (console: false/false)
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;

      // Si Swiper propose une méthode officielle
      if (swiper.isLocked && typeof swiper.unlock === "function") {
        swiper.unlock();
      }

      // Forcer l'état interne (certaines versions restent lock malgré tout)
      swiper.isLocked = false;

      // Retirer classes de lock si présentes
      el.classList.remove("swiper-lock", "swiper-locked", "swiper-disabled");
      if (swiper.wrapperEl) {
        swiper.wrapperEl.classList.remove("swiper-lock", "swiper-locked", "swiper-disabled");
      }

      // Laisse un peu de marge à droite (atteindre la 5e)
      swiper.params.slidesOffsetAfter = 120;

      // Recalcul
      swiper.update();
    } catch (e) {}
  }

  function patchAll() {
    if (!isMobile()) return;
    document.querySelectorAll(".dr-basic-widget .swiper").forEach((el) => {
      if (el && el.swiper) hardUnlock(el.swiper, el);
    });
  }

  // Doran / widget peut re-lock -> on re-force régulièrement (léger)
  setInterval(patchAll, 300);

  window.addEventListener("load", () => setTimeout(patchAll, 800));
  window.addEventListener("resize", () => setTimeout(patchAll, 200));
  document.addEventListener("touchstart", patchAll, { passive: true });
})();

